import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { AppTableSource, ColumnSortType, TableColumnTypes } from '../../../../../model/table.model';
import { map, Observable, Subject, take, takeUntil } from 'rxjs';
import { initUsersParams } from '../../../../../services/telegram.service';
import { IParams } from '../../../../../model/http';
import { NotificationService } from '../../../../../services/notifications.service';
import { environment } from '../../../../../../environments/environment';
import { IError } from '../../../../../interfaces';
import { ERROR_MESSAGES, activeTranslations } from '../../../../../enum/constants';
import { NovaPoshtaService } from '../../../../../services/nova-poshta.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { RightSidebarService } from '../../../../../services/right-sidebar.service';

export const tableHeaders = [
  // {
  //   value: 'primary',
  //   sort: ColumnSortType.NONE,
  //   name: '',
  //   type: TableColumnTypes.CHECKBOX,
  //   className: 'table-checkbox'
  // },
  {
    value: 'title',
    sort: ColumnSortType.NONE,
    name: 'Назва',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'api_key',
    sort: ColumnSortType.NONE,
    name: 'API KEY',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'action',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.ACTION,
    className: 'three-dot',
    actions: [{ icon: 'delete', label: 'delete', value: 'DELETE' }],
    translate: true,
  },
];

interface IFormNovaPoshta {
  title: FormControl;
  api_key: FormControl;
}

@Component({
  selector: 'app-integration-novaposhta',
  templateUrl: './integration-novaposhta.component.html',
  styleUrls: ['./integration-novaposhta.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class IntegrationNovaposhtaComponent implements OnInit, OnDestroy {
  private readonly destroy$: Subject<null> = new Subject<null>();

  dataSource$: Observable<AppTableSource> = this.newDeliveryService.lists$.pipe(
    map((data) => {
      this.integrationTotal = data.total || 0;
      return {
        headers: tableHeaders,
        rows: data.items,
        pageSize: data?.size || 0,
        pageIndex: data.page ? data.page - 1 : 0,
        length: data.total || 0,
      };
    }),
  );
  visibleColumns = tableHeaders.map((v) => v.value);

  integrationTotal!: number;

  private usersRequest: any;
  public phoneInput!: string;

  public form!: FormGroup<IFormNovaPoshta>;

  constructor(
    private readonly newDeliveryService: NovaPoshtaService,
    private readonly notificationService: NotificationService,
    private readonly rightSidebarService: RightSidebarService,
    private readonly router: Router,
  ) {}

  getUsersWithUpdatedParams(params: IParams) {
    if (this.usersRequest) {
      this.usersRequest.unsubscribe();
    }
    this.usersRequest = this.newDeliveryService
      .setQueryListsParams(params)
      .pipe(takeUntil(this.destroy$), take(1))
      .subscribe();
  }

  ngOnInit() {
    this.initForm();
    this.newDeliveryService.loadLists().pipe(takeUntil(this.destroy$), take(1)).subscribe();
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  onSortChange(e: any) {
    this.getUsersWithUpdatedParams({
      ...initUsersParams,
      sort: e.active,
      order: e.direction,
    });
  }
  onPaginationChange(paginationDetails: any) {
    const { pageIndex, pageSize } = paginationDetails;
    const page = pageIndex + 1;
    const take = pageSize;
    this.getUsersWithUpdatedParams({ page, take });
  }
  onActionChange(event: any) {
    if (event.label === 'DELETE') {
      this.newDeliveryService
        .removeApiKey(event.id)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            this.getUsersWithUpdatedParams({
              ...initUsersParams,
            });
          },
        });
    }
  }

  onRowClick(event: any) {
    this.rightSidebarService.close();
    this.router.navigate(['/crm/nova-poshta'], { queryParams: { cabinet: event.id } });
  }

  submit() {
    if (this.form.valid) {
      const payload = this.form.getRawValue();
      this.newDeliveryService.checkApiKey(payload.api_key).subscribe({
        next: () => {
          this.newDeliveryService
            .addApiKey(payload)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: () => {
                this.getUsersWithUpdatedParams({
                  ...initUsersParams,
                });
                this.phoneInput = '';
              },
              error: (res: any) => {
                (res.error?.errors || []).forEach((err: IError) => {
                  if (err.code === 'MAX_INTEGRATION') {
                    this.notificationService.showError(
                      '',
                      ERROR_MESSAGES[err.code].replace(
                        '{0}',
                        activeTranslations.nova_poshta,
                      ),
                    );
                  } else {
                    this.notificationService.showError('', ERROR_MESSAGES[err.code]);
                  }
                });
              },
            });
        },
        error: () => {
          this.notificationService.showError(
            '',
            activeTranslations.notifications_texts.error.API_key_invalid,
          );
        },
      });
    }
  }

  private initForm() {
    this.form = new FormGroup<IFormNovaPoshta>({
      title: new FormControl('Кабінет №1', Validators.required),
      api_key: new FormControl('', Validators.required),
    });
  }

  protected readonly environment = environment;
}
